export const GET_SINISTRES: '@sinistre/GET_SINISTRES' =
  '@sinistre/GET_SINISTRES';
export const SET_SINISTRES: '@sinistre/SET_SINISTRES' =
  '@sinistre/SET_SINISTRES';
export const GET_SINISTRES_FAILED: '@sinistre/GET_SINISTRES_FAILED' =
  '@sinistre/GET_SINISTRES_FAILED';
export const GET_SINISTRE_DETAILS: '@sinistre/GET_SINISTRE_DETAILS' =
  '@sinistre/GET_SINISTRE_DETAILS';
export const SET_SINISTRE_DETAILS: '@sinistre/SET_SINISTRE_DETAILS' =
  '@sinistre/SET_SINISTRE_DETAILS';
export const GET_SINISTRE_DETAILS_FAILED: '@sinistre/GET_SINISTRE_DETAILS_FAILED' =
  '@sinistre/GET_SINISTRE_DETAILS_FAILED';
export const GET_REFUNDS_AMC: '@global/GET_REFUNDS_AMC' =
  '@global/GET_REFUNDS_AMC';
export const SET_REFUNDS_AMC: '@global/SET_REFUNDS_AMC' =
  '@global/SET_REFUNDS_AMC';
export const GET_REFUNDS_AMC_FAILED: '@global/GET_REFUNDS_AMC_FAILED' =
  '@global/GET_REFUNDS_AMC_FAILED';
export const GET_REFUND_AMC_DETAILS: '@global/GET_REFUND_AMC_DETAILS' =
  '@global/GET_REFUND_AMC_DETAILS';
export const SET_REFUND_AMC_DETAILS: '@global/SET_REFUND_AMC_DETAILS' =
  '@global/SET_REFUND_AMC_DETAILS';
export const GET_REFUND_AMC_DETAILS_FAILED: '@global/GET_REFUND_AMC_DETAILS_FAILED' =
  '@global/GET_REFUND_AMC_DETAILS_FAILED';
